import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure226 = ({ hide }) => {
  const questionData = [
    {
      fieldName: "adviceMechanisms",
      title:
        "i. Describe the mechanisms for individuals to seek advice on implementing the organization’s policies and practices for responsible business conduct.",
    },
    {
      fieldName: "concernRaisingMechanisms",
      title:
        "ii. Describe the mechanisms for individuals to raise concerns about the organization’s business conduct.",
    },
  ];

  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 =
        res.data.data.GeneralDisclosures2021.mechanismForSeekingAdvice;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      adviceMechanisms: data?.adviceMechanisms || "",
      concernRaisingMechanisms: data?.concernRaisingMechanisms || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = " This field is Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        mechanismForSeekingAdvice: formData,
        type: "GeneralDisclosures2021",
        submitted2_26: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-27/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-27/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading}>
        2-26 Mechanisms for seeking advice and raising concerns
      </p>
      {/* a */}
      <Box sx={{ mt: hide ? "-2.5rem" : "2.5rem" }}>
        <p className={styles.ques_heading}>
          a. Provide the following information:
        </p>
        {/* b */}
        {questionData.map((el,i) => (
          <Box sx={{ ml:i===0? 2 :1.5}}>
            <p
              className={styles.ques_heading}
              style={{ textIndent: "-0.8rem",  }}
            >
              {el.title}
            </p>
            <Box sx={{ ml:i===0? 2 :2.5 }}>
              <InputField
                placeholder={"Enter Text"}
                fieldName={el.fieldName}
                mt="-5px"
                value={formData?.[el.fieldName]}
                handleChange={handleChange}
                errors={errors[el.fieldName] && true}
                disabled={disabled}
              />
              <p
                color="error"
                variant="caption"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el.fieldName]}
              </p>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure226;
